import { Typography, Box } from "@mui/material";

import Grid from "@mui/material/Unstable_Grid2";

import logo from "../../assetes/Forosh/LOGO EN.png";
import "./forosh.css";

const Forosh = () => {
  return (
    <>
      <Box sx={{ paddingLeft: 2 }}>
        <Typography variant="h2" sx={{ fontSize: "2rem", margin: 2 }}>
          واحد مهندسی فروش
        </Typography>
        <Typography
          variant="body1"
          sx={{ margin: 2, textAlign: "center", fontSize: "1.2rem" }}
        >
          کارشناسان مجرب این واحد ، علاوه بر ارائه مشاوره فنی و مالی و انتخاب
          مناسب ترین و مقرون به صرفه ترین تجهیز برای مشتریان ، پشتیبانی پس از
          مهندسی فروش را نیز به انجام می رسانند .<br></br>گروه صنعتی ایما ، توسط
          همکاران و شرکای تجاری خود در ترکیه و آلمان ، امکان تهیه سفارشی اقلام
          صنعتی مورد نیاز کارخانجات در زمینه کاری خود را دارد.{" "}
        </Typography>
        {/* <Typography
          variant="body1"
          sx={{ margin: 2, textAlign: "center", fontSize: "1.2rem" }}
        ></Typography> */}
        <Typography
          variant="body1"
          sx={{ margin: 2, textAlign: "center", fontSize: "1.2rem" }}
        >
          واحد فروش گروه صنعتی ایما جهت فروش اینترنتی محصولات قابل ارائه خود
          سایتی به نام دیجیماکالا به نشانی{" "}
          <span style={{ fontFamily: "roboto" }}>www.digimakala.com</span> راه
          اندازی نموده است.
        </Typography>
        <Typography variant="h6" sx={{ margin: 0 }}>
          برند های قابل ارائه:
        </Typography>
        <Grid container sx={{ display: "flex" }}>
          <Grid xs={12} sm={12} sx={{ xs: { display: "block", p: 0 } }}>
            <img
              src={logo}
              className="forosh-img"
              alt="برند های قابل ارائه"
              style={{
                marginRight: "150px",
                width: "70%",
              }}
            ></img>
          </Grid>
        </Grid>
      </Box>
    </>
  );
};

export default Forosh;
